<div class="mt-1 table_styleing">
  <table class="table table-borderless align-middle">
    <thead>
      <tr>
        <th class="bg_table" scope="col" *ngFor="let col of displayedColumns">
          {{ col | titlecase }}
        </th>
      </tr>
    </thead>
    <tbody class="tablebody">
      <tr *ngFor="let row of excelDataList; let i = index">
        <td *ngFor="let col of displayedColumns">
          <ng-container *ngIf="col !== 'actions'">
            <ng-container *ngIf="editingIndex === i">
              <input [(ngModel)]="row[col]" class="inputContainer" />
            </ng-container>
            <ng-container *ngIf="editingIndex !== i">
              {{ row[col] }}
            </ng-container>
          </ng-container>

          <ng-container *ngIf="col === 'actions'">
            <button
              *ngIf="editingIndex !== i"
              class="actionBtn"
              (click)="editRow(i)"
            >
              Edit
            </button>
            <div class="d-flex gap-2">
              <button
                *ngIf="editingIndex === i"
                class="actionBtn"
                (click)="saveRow()"
              >
                Save
              </button>
              <button
                *ngIf="editingIndex === i"
                class="actionBtn cancleBtn"
                (click)="cancelEdit()"
              >
                <i class="pi pi-times"></i>
              </button>
            </div>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div>
